import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  fetchFundCharts,
  fetchPortfolios,
  fetchHighInterestInvestments,
  fetchPortfoliosInvestments,
} from './wipActions';

const initialState = {
  investmentData: {},
  fundsByStatus: [],
  assetClassBreakdown: [],
  planExecution: [],
  portfolioList: [],
  portfolioInvestmentList: [],
  highInterestList: [],
  currentPortfolio: null,
  currentAssetClassFilter: '',
  currentStatusFilter: '',
  currentAsofDate: '',
};

export const getFundCharts = createAsyncThunk(
  'GET_FUND_CHARTS',
  async (requestObject) => {
    const { data, status } = await fetchFundCharts(requestObject);
    return { data, status };
  }
);

export const getPortfolios = createAsyncThunk(
  'GET_PORTFOLIOS',
  async (requestObject) => {
    const { data, status } = await fetchPortfolios(requestObject);
    return { data, status };
  }
);

export const getPortfoliosInvestments = createAsyncThunk(
  'GET_PORTFOLIOS_INVESTMENTS',
  async (requestObject) => {
    const { data, status } = await fetchPortfoliosInvestments(requestObject);
    return { data, status };
  }
);

export const getHighInterestPipeline = createAsyncThunk(
  'GET_HIGH_INTEREST_INVESTMENTS',
  async (requestObject) => {
    const { data, status } = await fetchHighInterestInvestments(requestObject);
    return { data, status };
  }
);

export const wipSlice = createSlice({
  name: 'wip',
  initialState,
  reducers: {
    setCurrentPortfolio: (state, action) => {
      state.currentPortfolio = action.payload;
    },
    setCurrentAssetClassFilter: (state, action) => {
      console.log('Updating Asset Class Filter to:', action);
      state.currentAssetClassFilter = action.payload;
    },
    setCurrentStatusFilter: (state, action) => {
      state.currentStatusFilter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFundCharts.fulfilled, (state, { payload }) => {
      state.investmentData = payload?.data.investmentData;
      state.fundsByStatus = payload?.data?.fundsByStatus;
      state.assetClassBreakdown = payload?.data?.assetClassBreakdown;
      state.planExecution = payload?.data?.planExecution;
      state.currentAsofDate = payload?.data?.asof_date;
    });
    builder.addCase(getPortfolios.fulfilled, (state, { payload }) => {
      state.portfolioList = payload?.data;
      if (!state.currentPortfolio && state.portfolioList.length > 0) {
        state.currentPortfolio = state.portfolioList[0]; // Default selection
      }
    });
    builder.addCase(
      getPortfoliosInvestments.fulfilled,
      (state, { payload }) => {
        state.portfolioInvestmentList = payload?.data;
      }
    );
    builder.addCase(getHighInterestPipeline.fulfilled, (state, { payload }) => {
      state.highInterestList = payload?.data;
    });
  },
});

// Actions
export const {
  setCurrentPortfolio,
  setCurrentAssetClassFilter,
  setCurrentStatusFilter,
} = wipSlice.actions;

// Selector to get the investment chart data
export const selectFundCharts = (state) => state.wip;

// Export the reducer
export default wipSlice.reducer;
